export default __webpack_public_path__ + "static/media/2C7E672D-9690-4DD8-BFF7-77579CE93305_1_105_c.59c52b93.jpeg";